export interface MiqValidatable {
  isValid(): boolean;
}

export const MiqValidatableType: MiqValidatable = {
  isValid: () => {
    throw new Error('Method not implemented.');
  },
};

export function validateElements(elementsToValidate: MiqValidatable[]): boolean {
  let isValid = true;
  elementsToValidate.forEach(element => {
    if (!element.isValid()) {
      isValid = false;
    }
  });
  return isValid;
}
